module.exports = __webpack_public_path__ + "media/images/page/top/top_icon_train-7d036ba819de6861ded73b1a245c750e.png";